module.exports = __webpack_public_path__ + "img/17-1_01.b616c532.jpg";